export const invoiceCategories = [
  { text: 'Ventas de mercaderías', value: 'Ventas de mercaderías (70000000)' },
  { text: 'Devoluciones de mercaderías', value: 'Devoluciones de mercaderías (70800000)' },
  { text: 'Prestaciones de servicios', value: 'Prestaciones de servicios (70500000)' },
  { text: 'Ingresos por arrendamientos', value: 'Ingresos por arrendamientos (75000000)' },
  { text: 'Ingresos por créditos', value: 'Ingresos por créditos (76200000)' },
];

export const operationTypes = [
  'Operación interior',
  'Entregas intracomunitarias',
  'Exportaciones',
  'Operaciones no sujetas',
  'Operación exenta de IVA',
];

export const availablePaymentMethods = [
  { text: 'No definido', value: 'No definido' },
  { text: 'Efectivo', value: 'Efectivo' },
  { text: 'Bizum', value: 'Bizum' },
  { text: 'Transferencia', value: 'Transferencia' },
  { text: 'Tarjeta bancaria', value: 'Tarjeta bancaria' },
  { text: 'Domiciliación bancaria', value: 'Domiciliación bancaria' },
  { text: 'Paypal', value: 'Paypal' },
];

export function itemTaxType(item) {
  if (
    item.tax === '21' ||
    item.tax === '12' ||
    item.tax === '10.5' ||
    item.tax === '10' ||
    item.tax === '7.5' ||
    item.tax === '5' ||
    item.tax === '4' ||
    item.tax === '2' ||
    item.tax === '0' ||
    item.tax === null
  ) {
    return 'iva';
  } else if (item.tax === '7' || item.tax === '3') {
    return 'igic';
  }
}

export function createEmptyTotalSelectedInvoiceData() {
  return {
    totalTaxBase: 0,
    totalTaxIVABase: 0,
    totalTaxIGICBase: 0,
    totalDiscount: 0,
    totalAmount: 0,
    totalTaxes: 0,
    totalIrpf: 0,
    totalTax21: 0,
    totalTax12: 0,
    totalTax105: 0,
    totalTax10: 0,
    totalTax75: 0,
    totalTax7: 0,
    totalTax5: 0,
    totalTax4: 0,
    totalTax3: 0,
    totalTax2: 0,
    totalTax0: 0,
    totalIrpf19: 0,
    totalIrpf15: 0,
    totalIrpf7: 0,
    totalIrpf2: 0,
    totalIrpf1: 0,
  };
}

export function createEmptySelectedTaxes() {
  return {
    tax21: false,
    tax12: false,
    tax105: false,
    tax10: false,
    tax75: false,
    tax7: false,
    tax5: false,
    tax4: false,
    tax2: false,
    tax3: false,
    tax0: false,
  };
}

export function createEmptySelectedIrpf() {
  return {
    irpf19: false,
    irpf15: false,
    irpf7: false,
    irpf2: false,
    irpf1: false,
  };
}

export function createEmptyItemsTax() {
  return {
    tax21: {
      base: 0,
      discounts: 0,
      taxes: 0,
    },
    tax12: {
      base: 0,
      discounts: 0,
      taxes: 0,
    },
    tax105: {
      base: 0,
      discounts: 0,
      taxes: 0,
    },
    tax10: {
      base: 0,
      discounts: 0,
      taxes: 0,
    },
    tax75: {
      base: 0,
      discounts: 0,
      taxes: 0,
    },
    tax7: {
      base: 0,
      discounts: 0,
      taxes: 0,
    },
    tax5: {
      base: 0,
      discounts: 0,
      taxes: 0,
    },
    tax4: {
      base: 0,
      discounts: 0,
      taxes: 0,
    },
    tax3: {
      base: 0,
      discounts: 0,
      taxes: 0,
    },
    tax2: {
      base: 0,
      discounts: 0,
      taxes: 0,
    },
    tax0: {
      base: 0,
      discounts: 0,
      taxes: 0,
    },
  };
}

export function generateCalculatedTotalSelectedInvoice(invoice) {
  let totalSelectedInvoiceData = createEmptyTotalSelectedInvoiceData();
  let selectedTaxes = createEmptySelectedTaxes();
  let selectedIrpf = createEmptySelectedIrpf();
  let itemsTax = createEmptyItemsTax();
  let totalSuplidos = 0;
  invoice.order_items.forEach(item => {
    // Total tax base
    let totalTaxBase = parseFloat(totalSelectedInvoiceData.totalTaxBase);
    if (item.type !== 'suplido') {
      totalSelectedInvoiceData.totalTaxBase = (
        totalTaxBase + parseFloat(item.total_amount)
      ).toFixed(2);
    } else {
      totalSuplidos = totalSuplidos + parseFloat(item.total_amount);
    }

    // Total tax IVA base
    if (itemTaxType(item) === 'iva' && item.type !== 'suplido') {
      let totalTaxIVABase = parseFloat(totalSelectedInvoiceData.totalTaxIVABase);
      totalSelectedInvoiceData.totalTaxIVABase = (
        totalTaxIVABase + parseFloat(item.total_amount)
      ).toFixed(2);
    }
    // Total tax IGIC base
    if (itemTaxType(item) === 'igic' && item.type !== 'suplido') {
      let totalTaxIGICBase = parseFloat(totalSelectedInvoiceData.totalTaxIGICBase);
      totalSelectedInvoiceData.totalTaxIGICBase = (
        totalTaxIGICBase + parseFloat(item.total_amount)
      ).toFixed(2);
    }

    // Total discounts
    if (item.discount_amount) {
      let totalDiscount = parseFloat(totalSelectedInvoiceData.totalDiscount);
      let discount =
        item.discount_type === 'percentage'
          ? (item.tax_base * item.discount_amount * item.quantity) / 100
          : item.discount_amount;
      totalSelectedInvoiceData.totalDiscount = (totalDiscount + parseFloat(discount)).toFixed(2);
    }

    // Total TAX 21%
    if (item.tax === '21') {
      selectedTaxes.tax21 = true;
      let totalTax21 = parseFloat(totalSelectedInvoiceData.totalTax21);
      totalSelectedInvoiceData.totalTax21 = (
        totalTax21 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
      // Split tax base for different taxes
      itemsTax.tax21.base = parseFloat(
        parseFloat(itemsTax.tax21.base) + parseFloat(item.total_amount),
      ).toFixed(2);
      itemsTax.tax21.taxes = totalSelectedInvoiceData.totalTax21;
    }
    // Total TAX 12%
    if (item.tax === '12') {
      selectedTaxes.tax12 = true;
      let totalTax12 = parseFloat(totalSelectedInvoiceData.totalTax12);
      totalSelectedInvoiceData.totalTax12 = (
        totalTax12 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
      // Split tax base for different taxes
      itemsTax.tax12.base = parseFloat(
        parseFloat(itemsTax.tax12.base) + parseFloat(item.total_amount),
      ).toFixed(2);
      itemsTax.tax12.taxes = totalSelectedInvoiceData.totalTax12;
    }
    // Total TAX 10,5%
    if (item.tax === '10.5') {
      selectedTaxes.tax105 = true;
      let totalTax105 = parseFloat(totalSelectedInvoiceData.totalTax105);
      totalSelectedInvoiceData.totalTax105 = (
        totalTax105 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
      // Split tax base for different taxes
      itemsTax.tax105.base = parseFloat(
        parseFloat(itemsTax.tax105.base) + parseFloat(item.total_amount),
      ).toFixed(2);
      itemsTax.tax105.taxes = totalSelectedInvoiceData.totalTax105;
    }
    // Total TAX 10%
    if (item.tax === '10') {
      selectedTaxes.tax10 = true;
      let totalTax10 = parseFloat(totalSelectedInvoiceData.totalTax10);
      totalSelectedInvoiceData.totalTax10 = (
        totalTax10 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
      // Split tax base for different taxes
      itemsTax.tax10.base = parseFloat(
        parseFloat(itemsTax.tax10.base) + parseFloat(item.total_amount),
      ).toFixed(2);
      itemsTax.tax10.taxes = totalSelectedInvoiceData.totalTax10;
    }
    // Total TAX 7,5%
    if (item.tax === '7.5') {
      selectedTaxes.tax75 = true;
      let totalTax75 = parseFloat(totalSelectedInvoiceData.totalTax75);
      totalSelectedInvoiceData.totalTax75 = (
        totalTax75 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
      // Split tax base for different taxes
      itemsTax.tax75.base = parseFloat(
        parseFloat(itemsTax.tax75.base) + parseFloat(item.total_amount),
      ).toFixed(2);
      itemsTax.tax75.taxes = totalSelectedInvoiceData.totalTax75;
    }
    // Total TAX IGIC 7%
    if (item.tax === '7') {
      selectedTaxes.tax7 = true;
      let totalTax7 = parseFloat(totalSelectedInvoiceData.totalTax7);
      totalSelectedInvoiceData.totalTax7 = (
        totalTax7 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
      // Split tax base for different taxes
      itemsTax.tax7.base = parseFloat(
        parseFloat(itemsTax.tax7.base) + parseFloat(item.total_amount),
      ).toFixed(2);
      itemsTax.tax7.taxes = totalSelectedInvoiceData.totalTax7;
    }
    // Total TAX 5%
    if (item.tax === '5') {
      selectedTaxes.tax5 = true;
      let totalTax5 = parseFloat(totalSelectedInvoiceData.totalTax5);
      totalSelectedInvoiceData.totalTax5 = (
        totalTax5 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
      // Split tax base for different taxes
      itemsTax.tax5.base = parseFloat(
        parseFloat(itemsTax.tax5.base) + parseFloat(item.total_amount),
      ).toFixed(2);
      itemsTax.tax5.taxes = totalSelectedInvoiceData.totalTax5;
    }
    // Total TAX 4%
    if (item.tax === '4') {
      selectedTaxes.tax4 = true;
      let totalTax4 = parseFloat(totalSelectedInvoiceData.totalTax4);
      totalSelectedInvoiceData.totalTax4 = (
        totalTax4 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
      // Split tax base for different taxes
      itemsTax.tax4.base = parseFloat(
        parseFloat(itemsTax.tax4.base) + parseFloat(item.total_amount),
      ).toFixed(2);
      itemsTax.tax4.taxes = totalSelectedInvoiceData.totalTax4;
    }
    // Total TAX IGIC 3%
    if (item.tax === '3') {
      selectedTaxes.tax3 = true;
      let totalTax3 = parseFloat(totalSelectedInvoiceData.totalTax3);
      totalSelectedInvoiceData.totalTax3 = (
        totalTax3 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
      // Split tax base for different taxes
      itemsTax.tax3.base = parseFloat(
        parseFloat(itemsTax.tax3.base) + parseFloat(item.total_amount),
      ).toFixed(2);
      itemsTax.tax3.taxes = totalSelectedInvoiceData.totalTax3;
    }
    // Total TAX 2%
    if (item.tax === '2') {
      selectedTaxes.tax2 = true;
      let totalTax2 = parseFloat(totalSelectedInvoiceData.totalTax2);
      totalSelectedInvoiceData.totalTax2 = (
        totalTax2 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
      // Split tax base for different taxes
      itemsTax.tax2.base = parseFloat(
        parseFloat(itemsTax.tax2.base) + parseFloat(item.total_amount),
      ).toFixed(2);
      itemsTax.tax2.taxes = totalSelectedInvoiceData.totalTax2;
    }
    // Total TAX 0%
    if ((item.tax === '0' || item.tax === null) && item.type !== 'suplido') {
      selectedTaxes.tax0 = true;
      let totalTax0 = parseFloat(totalSelectedInvoiceData.totalTax0);
      totalSelectedInvoiceData.totalTax0 = (
        totalTax0 + parseFloat((item.tax * item.total_amount) / 100)
      ).toFixed(2);
      // Split tax base for different taxes
      itemsTax.tax0.base = parseFloat(
        parseFloat(itemsTax.tax0.base) + parseFloat(item.total_amount),
      ).toFixed(2);
      itemsTax.tax0.taxes = totalSelectedInvoiceData.totalTax0;
    }
    // Total IRPF 19%
    if (item.irpf === '19' && item.type !== 'suplido') {
      selectedIrpf.irpf19 = true;
      let totalIrpf19 = parseFloat(totalSelectedInvoiceData.totalIrpf19);
      totalSelectedInvoiceData.totalIrpf19 = (
        totalIrpf19 + parseFloat((-item.irpf * item.total_amount) / 100)
      ).toFixed(2);
    }
    // Total IRPF 15%
    if (item.irpf === '15' && item.type !== 'suplido') {
      selectedIrpf.irpf15 = true;
      let totalIrpf15 = parseFloat(totalSelectedInvoiceData.totalIrpf15);
      totalSelectedInvoiceData.totalIrpf15 = (
        totalIrpf15 + parseFloat((-item.irpf * item.total_amount) / 100)
      ).toFixed(2);
    }
    // Total IRPF 7%
    if (item.irpf === '7' && item.type !== 'suplido') {
      selectedIrpf.irpf7 = true;
      let totalIrpf7 = parseFloat(totalSelectedInvoiceData.totalIrpf7);
      totalSelectedInvoiceData.totalIrpf7 = (
        totalIrpf7 + parseFloat((-item.irpf * item.total_amount) / 100)
      ).toFixed(2);
    }
    // Total IRPF 2%
    if (item.irpf === '2' && item.type !== 'suplido') {
      selectedIrpf.irpf2 = true;
      let totalIrpf2 = parseFloat(totalSelectedInvoiceData.totalIrpf2);
      totalSelectedInvoiceData.totalIrpf2 = (
        totalIrpf2 + parseFloat((-item.irpf * item.total_amount) / 100)
      ).toFixed(2);
    }
    // Total IRPF 1%
    if (item.irpf === '1' && item.type !== 'suplido') {
      selectedIrpf.irpf1 = true;
      let totalIrpf1 = parseFloat(totalSelectedInvoiceData.totalIrpf1);
      totalSelectedInvoiceData.totalIrpf1 = (
        totalIrpf1 + parseFloat((-item.irpf * item.total_amount) / 100)
      ).toFixed(2);
    }
  });

  // Total Taxes IVA + IGIC
  totalSelectedInvoiceData.totalTaxes =
    (parseFloat(totalSelectedInvoiceData.totalTax21) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalTax12) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalTax105) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalTax10) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalTax75) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalTax7) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalTax5) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalTax4) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalTax3) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalTax2) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalTax0) || 0);

  // Total Irpf
  totalSelectedInvoiceData.totalIrpf =
    (parseFloat(totalSelectedInvoiceData.totalIrpf19) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalIrpf15) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalIrpf7) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalIrpf2) || 0) +
    (parseFloat(totalSelectedInvoiceData.totalIrpf1) || 0);

  // Total amount
  totalSelectedInvoiceData.totalAmount = (
    parseFloat(totalSelectedInvoiceData.totalTaxBase) +
    totalSelectedInvoiceData.totalTaxes +
    totalSelectedInvoiceData.totalIrpf +
    totalSuplidos
  ).toFixed(2);

  invoice.total_amount = totalSelectedInvoiceData.totalAmount;
  invoice.tax_base = totalSelectedInvoiceData.totalTaxBase;

  return {
    invoice: invoice,
    totalData: totalSelectedInvoiceData,
    selectedTaxes: selectedTaxes,
    itemsTax: itemsTax,
    selectedIrpf: selectedIrpf,
    totalSuplidos: totalSuplidos,
  };
}
